import "@/App.css";
import { BrowserRouter, Routes, Route, Outlet } from "react-router-dom";
import { MotionConfig } from "framer-motion";
import { Toaster } from "sonner";

import { AuthProvider } from "@/context/AuthContext";
import SmoothScroll from "@/components/SmoothScroll";
import ScrollToTop from "@/components/ScrollToTop";
import Nav from "@/components/Nav";
import Footer from "@/components/Footer";

import Home from "@/pages/Home";
import Catalog from "@/pages/Catalog";
import CoursePage from "@/pages/CoursePage";
import Landing from "@/pages/Landing";
import LandingIndex from "@/pages/LandingIndex";
import Workshop from "@/pages/Workshop";
import About from "@/pages/About";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import Login from "@/pages/Login";
import Admin from "@/pages/Admin";

function SiteLayout() {
  return (
    <>
      <Nav />
      <main>
        <Outlet />
      </main>
      <Footer />
    </>
  );
}

function App() {
  return (
    <div className="App">
      <MotionConfig reducedMotion="user">
        <BrowserRouter>
          <AuthProvider>
            <SmoothScroll />
            <ScrollToTop />
            <Routes>
              <Route element={<SiteLayout />}>
                <Route path="/" element={<Home />} />
                <Route path="/courses" element={<Catalog />} />
                <Route path="/courses/:slug" element={<CoursePage />} />
                <Route path="/workshops/:slug" element={<Workshop />} />
                <Route path="/about" element={<About />} />
                <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                <Route path="/landing-pages" element={<LandingIndex />} />
              </Route>
              <Route path="/lp/:slug" element={<Landing />} />
              <Route path="/login" element={<Login />} />
              <Route path="/admin" element={<Admin />} />
            </Routes>
            <Toaster
              position="bottom-right"
              toastOptions={{
                style: {
                  borderRadius: 0,
                  border: "1px solid #0A0A0A",
                  background: "#F4F4F0",
                  color: "#0A0A0A",
                  fontFamily: "Manrope, sans-serif",
                },
              }}
            />
          </AuthProvider>
        </BrowserRouter>
      </MotionConfig>
    </div>
  );
}

export default App;
